export function capitalize(string, delimiter = ' ') {
    const words = string.split(delimiter)

    return words
        .map((word) => { if (word) return word[0].toUpperCase() + word.substring(1) })
        .join(' ')
}
